import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { isTesting, macroCondition } from '@embroider/macros';

export default class SpiderPortfolioRoute extends Route {
  @service declare access: Services['access'];

  beforeModel(): void {
    if (!this.access.hasFeature('spider.market.create')) {
      if (macroCondition(isTesting())) {
        throw new Error('Access denied');
      } else {
        window.location.href = '/';
      }
    }
  }
}
